import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import actions from "@/assets/utils/utils";

const getCertificadoAsistencia = async (idCita) => {
  const query = `                
    query qrGetDocumentAsistencia($idCita: String!) {
      getDocumentAsistencia(idCita: $idCita) {
        status
        message
        citaPdf
        cita{
          id
          fechaCita
          horaCita
          paciente{
            persona{
              primerNombre
              primerApellido
              identificacion
            }
          }
        }
      }
    }
  `;

  const variables = { idCita };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status === 200) {
      const item = response.data.data.getDocumentAsistencia.citaPdf;
      actions.cargarArchivos(
        item,
        `asistencia_${idCita}.pdf`,
        "data:application/pdf;base64"
      );
    }
  } catch (error) {
    console.error("Error al cargar la cobertura:", error);
  }
};

const getCertificadoDescanso = async (idCita) => {
  const query = `                
    query qrGetDocumentCertificado($idCita: String!) {
      getDocumentCertificado(idCita: $idCita) {
        status
        message
        citaPdf
        cita{
          id
          fechaCita
          horaCita
          paciente{
            persona{
              primerNombre
              primerApellido
              identificacion
            }
          }
        }
      }
    }
  `;

  const variables = { idCita };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status === 200) {
      const item = response.data.data.getDocumentCertificado.citaPdf;
      actions.cargarArchivos(
        item,
        `certificado_${idCita}.pdf`,
        "data:application/pdf;base64"
      );
    }
  } catch (error) {
    console.error("Error al cargar la cobertura:", error);
  }
};

const getForm033 = async (idCita) => {
  const query = `                
    query getForm033($idCita: String!) {
      getForm033(idCita: $idCita) {
        status
        message
        citaPdf
        cita{
          id
          fechaCita
          horaCita
          paciente{
            persona{
              primerNombre
              primerApellido
              identificacion
            }
          }
        }
      }
    }
  `;

  const sanitizedIdCita = String(idCita ?? '').trim();

  if (!sanitizedIdCita) {
    const message = "Identificador de cita inválido para generar el Formulario 033.";
    console.error(message, { idCita });
    throw new Error(message);
  }

  const variables = { idCita: sanitizedIdCita };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status === 200) {
      const form033 = response?.data?.data?.getForm033;

      if (!form033 || form033.status !== "success" || !form033.citaPdf) {
        const message =
          form033?.message || "No se encontró información para el Formulario 033.";
        throw new Error(message);
      }

      const item = form033.citaPdf;
      actions.cargarArchivos(
        item,
        `formulario033_${sanitizedIdCita}.pdf`,
        "data:application/pdf;base64"
      );
      return true;
    }

    throw new Error("Error inesperado al solicitar el Formulario 033.");
  } catch (error) {
    console.error("Error al descargar el Formulario 033:", error);
    if (error instanceof Error) {
      throw error;
    }
    throw new Error("No se pudo descargar el Formulario 033.");
  }
};

const getActaEntrega = async (idCita) => {
  const query = `                
    query qrGetDocumentActa($idCita: String!) {
      getDocumentActa(idCita: $idCita) {
        status
        message
        citaPdf
        cita{
          id
          fechaCita
          horaCita
          paciente{
            persona{
              primerNombre
              primerApellido
              identificacion
            }
          }
        }
      }
    }
  `;

  const variables = { idCita };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status === 200) {
      const item = response.data.data.getDocumentActa.citaPdf;
      actions.cargarArchivos(
        item,
        `acta_${idCita}.pdf`,
        "data:application/pdf;base64"
      );
    }
  } catch (error) {
    console.error("Error al cargar la cobertura:", error);
  }
};

const tieneDescanso = async (idCita) => {
  const query = `
    query MyQuery {
      getCertificadoByIdcita(idCita: ${idCita}) {
        message
        status
        certificado {
          actividadlab
          aislamiento
          contingencia
          diasdescanso
          empresa
          estado
          fechaCreacion
          id
          observacion
          token
          ultimoCambio
          residencia {
            callePrincipal
          }
        }
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + "api", { query });
    if (response.data.data.getCertificadoByIdcita.status === "success") {
      return true;
    }

    return false;
  } catch (error) {
    console.error("An error occurred while fetching descanso:", error);
    return null;
  }
};

// async downloadPlantillaServicio(idCita) {
//   const query = `
//     query plantillaServicio($idCita: String!) {
//       plantillaServicio(idCita: $idCita) {
//         status
//         message
//         citarchivo
//         cita{
//           id
//         }
//       }
//     }
//   `;

//   try {
//     const response = await axios.post(rutas.axios + 'api', {
//       query,
//       variables: {
//         idCita: idCita
//       }
//     });
//     if (response.status === 200) {
//       if (response.data.data.plantillaServicio) {
//         const item = response.data.data.plantillaServicio.citarchivo;
//         actions.cargarArchivos(item, "plantillaservicio_pdf", "data:application/pdf;base64");
//       } else {
//         this.$swal({
//           title: 'Error',
//           text: "El archivo no existe, comunicar con el adminsitrador sistema",
//           icon: 'error',
//           confirmButtonColor: '#089599',
//         })
//       }
//     }
//   } catch (error) {
//     this.$swal({
//       title: 'Error',
//       text: "Error al descargar el archivo",
//       icon: 'error',
//       confirmButtonColor: '#089599',
//     })
//   }
// },

// downloadEpidemiologia(idCita) {
//   actions.cargarArchivos([], "epidemiologia_" + idCita + ".pdf", "data:application/pdf;base64");
// }

export const informesService = {
  getCertificadoAsistencia,
  getCertificadoDescanso,
  getActaEntrega,
  tieneDescanso,
  getForm033,
};
